<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 38 38" style="enable-background:new 0 0 38 38;" :width="width" :height="height" xml:space="preserve">
        <g>
	        <g>
		        <path class="svg-outline-color" d="M19,38C8.52,38,0,29.48,0,19S8.52,0,19,0s19,8.52,19,19S29.48,38,19,38z M19,1C9.07,1,1,9.07,1,19
			        c0,9.92,8.07,18,18,18s18-8.08,18-18C37,9.07,28.93,1,19,1z"/>
	        </g>
                <path class="svg-secondary-color" d="M26.04,18.05c-1.43-0.27-2.08-1.94-1.22-3.12l0.6-0.82l-1.31-1.31l-0.81,0.55c-1.2,0.82-2.85,0.1-3.07-1.34
		            L20.08,11h-1.85l-0.24,1.24c-0.27,1.4-1.88,2.06-3.06,1.27l-1.05-0.71l-1.31,1.31l0.6,0.82c0.86,1.17,0.2,2.84-1.22,3.12L11,18.23
		            v1.85l1.01,0.16c1.44,0.22,2.15,1.86,1.34,3.07l-0.55,0.81l1.31,1.31l0.82-0.6c1.17-0.86,2.84-0.21,3.12,1.22L18.23,27h1.85
		            l0.11-0.71c0.23-1.47,1.93-2.18,3.13-1.3l0.58,0.43l1.31-1.31l-0.55-0.81c-0.82-1.2-0.1-2.85,1.34-3.07L27,20.08v-1.85L26.04,18.05
		            z M19.15,22.15c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3S20.81,22.15,19.15,22.15z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "settingsIcon",
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        }
    }
}
</script>

<style scoped lang="scss">
    .st1 {
        fill: $color-svg-fill;
    }
</style>



// WEBPACK FOOTER //
// src/common/components/svg/shared/settingsIcon.vue